export default "__VITE_ASSET__CpzM$OpE__"